import { render, staticRenderFns } from "./AgentCommissionChart.vue?vue&type=template&id=2ec65fba&scoped=true&lang=pug&"
import script from "./AgentCommissionChart.vue?vue&type=script&lang=js&"
export * from "./AgentCommissionChart.vue?vue&type=script&lang=js&"
import style0 from "./AgentCommissionChart.vue?vue&type=style&index=0&id=2ec65fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec65fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow,VSpacer})
